import { useSelector } from "react-redux";

import { authStore } from "store/slices/auth";

function useAuth() {
  const {
    per, role, token, authUser, authPer, branchOfficeCd, companyName
  } = useSelector(authStore);
  return { per, role, token, authUser, authPer, branchOfficeCd, companyName };
}

export default useAuth;
